// src/components/Footer.jsx
import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import { NavLink } from 'react-router-dom';
import { assets } from "../assets/assets.js";

const Footer = () => {
  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/About' },
    { label: 'Collection', path: '/Collection' },
    { label: 'Contact', path: '/Contact' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Data Deletion', path: '/data-deletion' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.secondary',
        py: 6,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <img src={assets.logo} alt="Gupta Decor" style={{ height: 40, marginRight: '12px' }} />
              <Typography variant="h5" color="text.primary" fontWeight="bold">
                Gupta Decor
              </Typography>
            </Box>
            <Typography variant="body2">
              Your one-stop shop for the finest home decor and furnishings.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Quick Links
            </Typography>
            {quickLinks.map((link) => (
              <Link
                key={link.label}
                component={NavLink}
                to={link.path}
                variant="body2"
                color="text.secondary"
                underline="hover"
                sx={{ display: 'block', mb: 1 }}
              >
                {link.label}
              </Link>
            ))}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2">123 Decor Street, Design City</Typography>
            <Typography variant="body2">Email: nilesh@guptadecoration.com</Typography>
            <Typography variant="body2">Phone: (123) 456-7890</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Follow Us
            </Typography>
            <Box>
              <IconButton aria-label="Facebook" color="inherit" href="https://facebook.com">
                <FacebookIcon />
              </IconButton>
              <IconButton aria-label="Twitter" color="inherit" href="https://twitter.com">
                <TwitterIcon />
              </IconButton>
              <IconButton aria-label="Instagram" color="inherit" href="https://instagram.com">
                <InstagramIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ pt: 4, mt: 4, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" align="center">
            &copy; {new Date().getFullYear()} Gupta Decor. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
